import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { pctSymbol } from '../../utils/formatters';

const Gauge = ({ percent = 0, icon: Icon, iconClass = '' }) => {
  const p = Math.max(0, Math.min(100, Number(percent || 0)));
  const size = 140;
  const center = size / 2;
  const radius = 56;
  const circumference = Math.PI * radius;
  const progress = (p / 100) * circumference;
  const iconY = center - (radius * 0.55) - 16;
  return (
    <svg viewBox={`0 0 ${size} ${size/2}`} className="w-full h-[90px]">
      <path d={`M ${center-radius},${center} A ${radius},${radius} 0 0 1 ${center+radius},${center}`} fill="none" stroke="var(--succession-border)" strokeWidth="10" />
      <path d={`M ${center-radius},${center} A ${radius},${radius} 0 0 1 ${center+radius},${center}`} fill="none" stroke="var(--succession-warning)" strokeWidth="10" strokeDasharray={`${progress} ${circumference}`} />
      <foreignObject x={center-16} y={iconY} width="32" height="32">
        <div className="w-8 h-8 rounded-full bg-succession-bg-secondary border border-succession-border flex items-center justify-center">
          {Icon ? <Icon className={`w-5 h-5 text-succession-warning ${iconClass}`} /> : null}
        </div>
      </foreignObject>
    </svg>
  );
};

const GET_CATASTROPHE_STATUS = gql`
  query CatastrophicPlanStatusCard {
    catastropheFormDatum { id status completionPercentage currentSectionName }
  }
`;

const CatastrophicPlanCard = ({ status: statusProp, percent: percentProp }) => {
  const { data } = useQuery(GET_CATASTROPHE_STATUS, { fetchPolicy: 'cache-first' });
  const apiStatus = data?.catastropheFormDatum?.status;
  const apiPct = data?.catastropheFormDatum?.completionPercentage;
  const status = (statusProp || apiStatus || 'not_started');
  const isNotStarted = status === 'not_started';
  const isCompleted = status === 'completed';
  const percent = (percentProp != null ? percentProp : apiPct);
  const pct = isCompleted ? 100 : (isNotStarted ? 0 : Math.max(1, Math.min(99, Number(percent||0))));

  return (
    <div className="bg-succession-bg-primary overflow-hidden shadow-succession-md rounded-lg h-full border border-succession-border">
      <div className="px-4 py-5 sm:p-6 h-full flex flex-col">
        <h3>Catastrophic Plan</h3>
        <h4 className="text-sm text-succession-text-secondary">Emergency & Catastrophe Planning</h4>
        <div className="mt-3 flex-1 flex flex-col items-center justify-center">
          <Gauge percent={pct} icon={ExclamationTriangleIcon} />
          <div className="mt-2 text-xs text-succession-text-secondary">
            {isCompleted ? 'Completed' : isNotStarted ? 'Prepare for the unexpected. Ensure your legacy survives catastrophe.' : `${pct}${pctSymbol()} complete`}
          </div>
        </div>
        <div className="mt-auto pt-2 flex justify-center">
          {isNotStarted && (
            <a href="/succession/catastrophe" className="text-sm text-succession-primary hover:text-succession-primary-hover">Create Catastrophic Plan &gt;</a>
          )}
          {!isNotStarted && !isCompleted && (
            <a href="/succession/catastrophe" className="text-sm text-succession-primary hover:text-succession-primary-hover">Continue Catastrophic Plan &gt;</a>
          )}
          {isCompleted && (
            <a href="/succession/catastrophe" className="text-sm text-succession-primary hover:text-succession-primary-hover">Review Catastrophic Plan &gt;</a>
          )}
        </div>
      </div>
    </div>
  );
};

export default CatastrophicPlanCard;


